module.exports = __webpack_public_path__ + "7a18a82172fc0d8656e56a54a623cd2e.jpg";